<template>
  <div>
    <v-card-text>
      <v-form @submit.prevent="save()" ref="form" :disabled="disableForm"> 
        <v-row dense>
          <v-col class="d-flex" cols="12" sm="2">
            <v-radio-group :rules="formRules" v-model="reportsForm.use_alcohol">
              <p>{{ $t('inputs.pcr_clinical_histories.use_alcool') }}<span style="color: red">*</span></p>

              <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>

              <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col class="d-flex" cols="12" sm="3">
            <v-radio-group
              :rules="formRules"
              v-model="reportsForm.use_ilicit_injectable_drugs"
            >
              <p>
                {{ $t('inputs.pcr_clinical_histories.use_drugs') }}<span style="color: red"
                  >*</span
                >
              </p>

              <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>

              <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>

              <v-radio
                :label="$t('options.dont_know')"
                value="NÃO SABE INFORMAR"
                color="#086318"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-radio-group
              :rules="formRules"
              v-model="reportsForm.facial_trauma"
            >
              <p>{{ $t('inputs.pcr_clinical_histories.facial_trauma') }}<span style="color: red">*</span></p>

              <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>

              <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-radio-group
              :rules="formRules"
              v-model="reportsForm.corneal_surgery_report"
            >
              <p>
                {{ $t('inputs.pcr_clinical_histories.corneal_surgery') }}<span style="color: red">*</span>
              </p>

              <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>

              <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>

              <v-radio
                :label="$t('options.dont_know')"
                value="NÃO SABE INFORMAR"
                color="#086318"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col class="d-flex" cols="12" sm="3">
            <v-radio-group
              :rules="formRules"
              v-model="reportsForm.use_vaccine_last_30_days"
            >
              <p>
                {{ $t('inputs.pcr_clinical_histories.use_vaccine') }}<span style="color: red">*</span>
              </p>

              <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>

              <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>

              <v-radio
                :label="$t('options.dont_know')"
                value="NÃO SABE INFORMAR"
                color="#086318"
              ></v-radio>

              <v-text-field text color="#086318" v-model="reportsForm.which_vaccine_last_30_days"
                v-if="use_vaccine_last_30_days">
                <template v-slot:label>
                  {{ $t('inputs.pcr_clinical_histories.wich_vaccine') }} <span style="color: red">*</span>
                </template>
              </v-text-field>
            </v-radio-group>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-radio-group
              :rules="formRules"
              v-model="reportsForm.antibiotic_use"
            >
              <p>
                {{ $t('inputs.pcr_clinical_histories.use_antibiotic') }}<span
                  style="color: red"
                  >*</span
                >
              </p>

              <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>

              <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            </v-radio-group>
          </v-col>
          <v-form @submit.prevent="addAntibiotic" ref="antibiotic">
            <v-row dense>
              <v-col
                class="d-flex"
                cols="12"
                sm="4"
                v-if="reportsForm.antibiotic_use == 'SIM'"
              >
                <v-text-field 
                  color="#086318"
                  dense
                  v-model="antibioticForm.infection_antibiotic"
                >
                  <template v-slot:label>
                    {{ $t('inputs.pcr_clinical_histories.type_antibiotic') }}
                  </template>
                </v-text-field>
              </v-col>
              <v-col
                class="d-flex"
                cols="12"
                sm="3"
                v-if="reportsForm.antibiotic_use == 'SIM'"
              >
                <v-text-field
                  color="#086318" 
                  dense
                  v-model="antibioticForm.dose_of_antibiotic"
                >
                  <template v-slot:label>
                    {{ $t('inputs.pcr_clinical_histories.dose') }}
                  </template>
                </v-text-field>
              </v-col>
              <v-col
                class="d-flex"
                cols="12"
                sm="4"
                v-if="reportsForm.antibiotic_use == 'SIM'"
              >
                <v-text-field
                  color="#086318" 
                  type="date"
                  @input="onlyDateInput('antibioticForm' ,'antibiotic_start_date' , $event)"
                  :max="maxDate"
                  dense
                  v-model="antibioticForm.antibiotic_start_date"
                >
                  <template v-slot:label>
                    {{ $t('inputs.pcr_clinical_histories.date') }}
                  </template>
                </v-text-field>
              </v-col>
              <v-col
                class="d-flex"
                cols="12"
                sm="1"
                v-if="reportsForm.antibiotic_use == 'SIM'"
              >
                <v-tooltip top color="green">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-1"
                      x-small
                      elevation="0"
                      fab
                      dark
                      color="green"
                      v-bind="attrs"
                      v-on="on"
                      @click="addAntibiotic()"
                    >
                      <v-icon dark> mdi-plus </v-icon>
                    </v-btn>
                  </template>
                  <span style="color: white">{{ $t('options.add') }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-form>
        </v-row>
        <div>
          <v-data-table
            v-if="enableGrid"
            :headers="headers"
            :items="antibioticItems"
            :page="page"
            :loading="loading"
          >
            <template #no-data>
              <div class="text-center py-4">{{ $t('messages.no_data_found') }}</div>
            </template>

            <template v-slot:[`item.action`]="{ item }" :resource="item">
              <v-tooltip bottom color="#3fa118">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    size="22"
                    class="icon"
                    color="red"
                    align-item="center"
                    v-on="on"
                    v-bind="attrs"
                    @click="deletAntibiotic(item)"
                    >mdi-trash-can
                  </v-icon>
                </template>
                <span style="color: white">Apagar Antibiótico</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.beggins`]="{ item }">
              {{ formatDate(item.antibiotic_start_date) }}
            </template>
          </v-data-table>
        </div>

        <div class="buttons mt-8 d-flex">
          <v-row dense class="justify-center">
            <v-btn
              v-if="!disableForm"
              class="rounded-lg mr-1"
              elevation="0"
              color="#41916b"
              type="submit"
            >
              <span style="color: white">{{$t('buttons.save')}}</span>
            </v-btn>
            <BackToGridBtn />
          </v-row>
        </div>
      </v-form>
    </v-card-text>
  </div>
</template>
<script>
import axios from "@/axios";
import { mapActions, mapGetters } from "vuex";
import dateTimeLimit from "@/utils/dateTimeLimit"; 
import currentUser from "@/utils/currentUser";
import BackToGridBtn from "@/components/widgets/BackToGridBtn";
export default {
  data() {
    return {
      loading: false,
      disableForm: false,
      antibioticForm: {},
      reportsForm: {},
      formRules: [(v) => !!v || this.$t('messages.required_field')],
      antibioticItems: [],
      page: 0,
      headers: [
        {
          text: "Antibiótico",
          align: "center",
          value: "infection_antibiotic",
        },
        {
          text: "Dose",
          align: "center",
          value: "dose_of_antibiotic",
        },

        {
          text: "Início",
          align: "center",
          value: "beggins",
        },

        {
          text: "Deletar",
          align: "center",
          value: "action",
        },
      ],
      enableGrid: false,
    };
  },

  components: {
    BackToGridBtn  
  },

  props: {
    patientData: Object, 
  },

  watch: {
    clinicalHistories: {
      handler (item) { 
        if(item){ 
          if(parseInt(item.donor_id) == parseInt(this.patientData.id)){
            this.reportsForm = item; 
            this.getAntibioticItems();
            this.enableGrid = true;
          } 
        }
      },
      immediate: true,
    },
  },

  computed: {
    ...mapGetters({
      clinicalHistories: "getClinicalHistories",
    }),

    currentUser(){
      return currentUser.getUserData()
    },

    maxDate() {
      const now = new Date()
      return now.toISOString().slice(0, 10)
    },

    use_vaccine_last_30_days() {
      return this.reportsForm.use_vaccine_last_30_days == "SIM"
    }
  },

  methods: {
    ...mapActions(["changeSnackBarData"]),

    onlyDateInput(path,field, value) {  
       this[path][field] =
        dateTimeLimit.limiteInputOnlyDate(value)
    },

    save() {   
      if (this.$refs.form.validate()) {
        let data = { ...this.reportsForm };
        data.donor_id = this.patientData.id;
        data.user_id = this.currentUser.id;

        const hasData = !!this.clinicalHistories?.id
 
        axios({
          method: hasData ? "PUT" : "POST",
          url: hasData 
            ? `/clinical_histories/${this.clinicalHistories.id}`
            : `/clinical_histories`,
          data,
        })
          .then((response) => {
            if(!hasData){ 
              this.disableForm = true;
            }

            this.getAntibioticItems();
            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message,
              bodyMessage: "",
              cardColor: "success",
              titleIcon: "mdi-check-circle",
            });

            setTimeout(() => {
              this.$emit("changeTab", 1);
              this.closeSnackBar();
            }, 3000);
          })
          .catch((err) => {
            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: err.error,
              bodyMessage: err.details,
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });

            setTimeout(() => {
              this.closeSnackBar();
            }, 3000);
          });
      }
    },

    addAntibiotic() {
      if (this.$refs.antibiotic.validate()) {
        let antibiotic = { ...this.antibioticForm };
        antibiotic.donor_id = this.patientData.id;

        axios
          .post("/antibiotics", antibiotic)
          .then((response) => {
            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message,
              bodyMessage: "",
              cardColor: "success",
              titleIcon: "mdi-check-circle",
            });

            setTimeout(() => {
              this.antibioticForm = {};
              this.$refs.antibiotic.resetValidation();
              this.getAntibioticItems();
              this.closeSnackBar();
            }, 3000);
          })
          .catch((err) => {
            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: this.$t('messages.something_went_wrong'),
              bodyMessage: err.details,
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });

            setTimeout(() => {
              this.closeSnackBar();
            }, 3000);
          });
      }
    },

    getAntibioticItems() {
      let id = this.patientData.id;

      axios.get(`/antibiotics/byDonor/${id}`).then((response) => {
        this.antibioticItems = response.data;
        if (this.antibioticItems.length >= 1) {
          this.enableGrid = true;
        }
      });
    },

    deletAntibiotic(item) {
      axios
        .delete(`/antibiotics/${item.id}`)
        .then((response) => {
          this.changeSnackBarData({
            status: true,
            type: "success",
            titleMessage: response.data.message,
            bodyMessage: "",
            cardColor: "success",
            titleIcon: "mdi-check-circle",
          });

          setTimeout(() => {
            this.getAntibioticItems();
            this.closeSnackBar();
          }, 3000);
        })
        .catch((err) => {
          this.changeSnackBarData({
            status: true,
            type: "erro",
            titleMessage: this.$t('messages.something_went_wrong'),
            bodyMessage: err.details,
            cardColor: "red",
            titleIcon: "mdi-close-circle",
          });

          setTimeout(() => {
            this.getAntibioticItems();
            this.closeSnackBar();
          }, 3000);
        });
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  },
};
</script>
